import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './IndustryInfo.scoped.less';

class IndustryInfo extends React.Component {
  static propTypes = {
    industryId: PropTypes.number,
    industryIds: PropTypes.array,
    industry: PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      className: PropTypes.string,
    }),
    parent: PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      className: PropTypes.string,
    }),
  }

  getIndustryName(industryIds) {
    const { industryRepo = {} } = this.props;
    return _.map(industryIds, (industryId) => {
      const industry = industryRepo[industryId];
      const parent =  industry && industry.parentId !== 0 ? industryRepo[industry.parentId] : undefined;
      const firstText  = parent && parent.level > 0 ? parent.displayName : '';
      const secondText = industry.displayName;
      return firstText ? `${firstText}/${secondText}` : secondText;
    }).join(',');
  }

  render() {
    const { industry, industryId, parent, industryIds = [] } = this.props;
    // 支持解析多个行业Id
    if(!_.isEmpty(industryIds)) {
      return this.getIndustryName(industryIds);
    }
    if (!industry) {
      return <span className="IndustryInfo">{industryId === 0 ? <i>未知行业</i> : industryId}</span>;
    }

    return (
      <span className="IndustryInfo">
        {parent && parent.level > 0 && <span className={`parent ${parent.className}`}>{parent.displayName}</span>}
        <span className={industry.className}>{industry.displayName}</span>
      </span>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const industry = state.industryRepo[ownProps.industryId];
  return {
    industry,
    parent: industry && industry.parentId !== 0 ? state.industryRepo[industry.parentId] : undefined,
    industryRepo: state.industryRepo,
  };
}

export default connect(mapStateToProps)(IndustryInfo);
